/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Placement of the Emergency Alert System (EAS) OSD on screen.
 *
 * Corresponds to the `#EAS POSITION#` variable in the EAS OSD specification and
 * determines which OSD template is rendered for a given country.
 */
export enum EasOsdPosition {
  /** Alert bar anchored to the top of the screen. */
  Top = "top",

  /** Alert bar anchored to the bottom of the screen. */
  Bottom = "bottom",

  /** Full-screen alert (supports bilingual titles). */
  FullScreen = "fullScreen"
}
